import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogSurface,
  DialogTitle,
  mergeClasses,
  Button
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';
import { ClipchampPlayer } from '../player';

import { previewClipchampVideoModalStyles } from './style';

export const PreviewClipchampVideoModal = ({
  i18n,
  videoUrl,
  show,
  onClose,
  logger,
  loadClipchampPlayer,
}) => {
  const DismissIcon = useMemo(() => <Button icon={<Dismiss20Regular />} aria-label="Cancel" onClick={onClose} />, [onClose]);

  const classes = previewClipchampVideoModalStyles();

  return (
    <Dialog
      open={show}
      onDismiss={onClose}
      className={mergeClasses('preview-clipchamp-video-dialog', classes.dialog)}
    >
      <DialogSurface className={mergeClasses('preview-clipchamp-video-dialog', classes.dialog)}>
        <DialogBody>
          <DialogTitle action={DismissIcon}>
            {i18n.getString(_TL_('Video Preview'))}
          </DialogTitle>
          <DialogContent className={classes.dialogContent} >
            <div className={classes.dialogContentContainer}>
              <ClipchampPlayer videoUrl={videoUrl} width="100%" logger={logger} loadClipchampPlayer={loadClipchampPlayer} i18n={i18n} />
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

PreviewClipchampVideoModal.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logError: PropTypes.func,
  }).isRequired,
};
